import { __extends } from "tslib";
import { deserializeAws_restXmlPutPublicAccessBlockCommand, serializeAws_restXmlPutPublicAccessBlockCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutPublicAccessBlockCommand = /** @class */ (function (_super) {
    __extends(PutPublicAccessBlockCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutPublicAccessBlockCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutPublicAccessBlockCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutPublicAccessBlockCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutPublicAccessBlockCommand(input, context);
    };
    PutPublicAccessBlockCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutPublicAccessBlockCommand(output, context);
    };
    return PutPublicAccessBlockCommand;
}($Command));
export { PutPublicAccessBlockCommand };
//# sourceMappingURL=PutPublicAccessBlockCommand.js.map